import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-searcher";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class UniversalFieldDataSource {
    ViewModel = ko.observable();
    tabPage: TabPage;
    constructor(public TabPage: TabPage, parent: any) {
        this.tabPage = TabPage;
        this.ViewModel = parent;
    }
    InitUrl() {
        return "UniversalField/Init";
    }
}
export default UniversalFieldDataSource;